import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostCreateOrganization = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CREATE_OBJECT
            });
            dispatch(Action.SetGetListOrganization({
                search: ''
            }));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateOrganization as SetPostCreateOrganization
}